var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive mt-3"},[_c('table',{staticClass:"table table-sm table-condensed table-bordered"},[_c('tbody',_vm._l((_vm.details),function(detail,name){return _c('tr',{key:name},[_c('td',[_vm._v(_vm._s(name))]),_c('td',[_vm._v(_vm._s(detail))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }